export default "__VITE_ASSET__C7mI6vL8__"